import React, {useEffect, useRef, useState} from 'react';
import folderLight from "../../../assets/folderLight.svg";
import folderDark from "../../../assets/folderDark.svg";
import FilesDropdown from "./FilesDropdown.tsx";
import {useAppStore} from "../../../GlobalStore/GlobalStore.ts";

interface FilesProps {}

const Files: React.FC<FilesProps> = ({ }) => {
    const settingsObj = useAppStore((state: any) => state.settingsObj);
    const { theme } = settingsObj;
    const environmentObj = useAppStore((state: any) => state.environmentObj);
    const { environment, vscode } = environmentObj;
    const dynamicStateObj = useAppStore((state: any) => state.dynamicStateObj);
    const { isMenuOpen, openFileStatuses } = dynamicStateObj;

    const [isOpen, setIsOpen] = useState(false);
    const dropdownRef = useRef<any>(null);

    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
                setIsOpen(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    useEffect(() => {
        if (openFileStatuses.length === 0 || !isOpen) return;

        const openFiles = openFileStatuses.map((file: any) => file.filePath);
        
        if (environment.includes("jetbrains")) {
            window.jetbrainsPostMessage(JSON.stringify({
                functionName: "checkGhostFiles",
                data: [{openFiles: JSON.stringify(openFiles)}]
            }));
        } else if (environment === "vscode") {
            vscode.postMessage({functionName: "checkGhostFiles", data: [{openFiles: openFiles}]});
        }
    }, [isOpen]);

    const getFilesStyles = () => {
        const styles = [];
        styles.push(environment.includes("jetbrains") ? "ml-3 mr-auto" : "ml-auto mr-3");
        if (isMenuOpen) styles.push("opacity-30");
        return styles.join(' ');
    }
    const filesStyles = getFilesStyles();

    return (
        <div ref={dropdownRef} className={`relative h-6 w-6 ${filesStyles} ${isMenuOpen ? "opacity-30" : ""}`}>
            <button onClick={() => setIsOpen(!isOpen)}>
                <img
                    src={`${theme === 'dark' ? folderLight : folderDark}`}
                    alt="Files"
                />
            </button>
            {isOpen && (
                <FilesDropdown />
            )}
        </div>
    );
};

export default Files;